import React, { useState } from "react";
import { questions, domainResultsTextData, domainData } from "./Data";
import Overall from "./OverallResult";
import { Row, Col } from "react-bootstrap";
import "./StudentStressScale.css";
import { connect } from "react-redux";
import { myFirestore } from "../../../services/firebase";

let financial = 0,
  family = 0,
  social = 0,
  education = 0,
  egoThreat = 0,
  bereavement = 0,
  separation = 0,
  setBack = 0,
  health = 0;

let overall = 0;

function ScoreCard(props) {
  var result = "";
  if (overall < 30) {
    result = "Low Stress";
  } else if (overall >= 30 && overall <= 50) {
    result = "Average Stress";
  } else if (overall > 50) {
    result = "High Stress";
  }
  return (
    <div className="result-div-sss">
      <h3>Results</h3>
      <Overall resultOverall={result} results={props.results} />
    </div>
  );
}

function StudentStressScale(props) {
  const [qno, setQno] = useState(0);
  let [ansArray] = useState([]);
  let [results] = useState([]);
  const [show, setShow] = useState(true);

  let ans = 0;

  function computeScore() {
    let temp = 0;

    temp = ansArray[0] + ansArray[1] + ansArray[2] + ansArray[3] + ansArray[59];
    financial = (temp / 35) * 100;
    results.push(financial);

    temp =
      ansArray[4] +
      ansArray[5] +
      ansArray[6] +
      ansArray[7] +
      ansArray[11] +
      ansArray[19] +
      ansArray[58] +
      ansArray[62];
    family = (temp / 56) * 100;
    results.push(family);

    temp = ansArray[8] + ansArray[10] + ansArray[40] + ansArray[42];
    social = (temp / 28) * 100;
    results.push(social);

    temp =
      ansArray[9] +
      ansArray[20] +
      ansArray[22] +
      ansArray[23] +
      ansArray[43] +
      ansArray[44] +
      ansArray[45] +
      ansArray[46] +
      ansArray[47] +
      ansArray[48] +
      ansArray[49] +
      ansArray[50] +
      ansArray[51] +
      ansArray[52] +
      ansArray[53] +
      ansArray[54] +
      ansArray[55] +
      ansArray[56] +
      ansArray[57];
    education = (temp / 133) * 100;
    results.push(education);

    temp =
      ansArray[12] +
      ansArray[13] +
      ansArray[14] +
      ansArray[15] +
      ansArray[17] +
      ansArray[18] +
      ansArray[21] +
      ansArray[25] +
      ansArray[60];
    egoThreat = (temp / 63) * 100;
    results.push(egoThreat);

    temp = ansArray[27] + ansArray[28] + ansArray[29] + ansArray[30];
    bereavement = (temp / 28) * 100;
    results.push(bereavement);

    temp = ansArray[31] + ansArray[32] + ansArray[41];
    separation = (temp / 21) * 100;
    results.push(separation);

    temp =
      ansArray[16] +
      ansArray[24] +
      ansArray[26] +
      ansArray[33] +
      ansArray[34] +
      ansArray[61] +
      ansArray[63];
    setBack = (temp / 49) * 100;
    results.push(setBack);

    temp =
      ansArray[35] + ansArray[36] + ansArray[37] + ansArray[38] + ansArray[39];
    health = (temp / 35) * 100;
    results.push(health);

    temp =
      financial +
      family +
      social +
      education +
      egoThreat +
      bereavement +
      separation +
      setBack +
      health;

    overall = (temp / 64) * 100;

    if (props.auth.uid) {
      myFirestore
        .collection("testresults")
        .doc(props.auth.uid)
        .set(
          {
            StressScale: {
              overall: overall,
              financial: financial,
              family: family,
              social: social,
              education: education,
              egoThreat: egoThreat,
              bereavement: bereavement,
              separation: separation,
              setBack: setBack,
              health: health,
            },
          },
          { merge: true }
        );
    } else {
      myFirestore
        .collection("anonresults")
        .doc()
        .set({
          StressScale: {
            overall: overall,
            financial: financial,
            family: family,
            social: social,
            education: education,
            egoThreat: egoThreat,
            bereavement: bereavement,
            separation: separation,
            setBack: setBack,
            health: health,
          },
        });
    }

    var i;

    for (i = 0; i < 9; i++) {
      if (results[i] < 30) {
        domainData[i]["result"] = "a low";
        domainData[i]["text2"] = domainResultsTextData[i][0];
        domainData[i]["color"] = "#99d199";
      } else if (results[i] >= 30 && results[i] <= 50) {
        domainData[i]["result"] = "an average";
        domainData[i]["text2"] = domainResultsTextData[i][1];
        domainData[i]["color"] = "#f3e355";
      } else if (results[i] > 50) {
        domainData[i]["result"] = "a high";
        domainData[i]["text2"] = domainResultsTextData[i][2];
        domainData[i]["color"] = "#f87979";
      }
    }
  }

  function handleClick(e) {
    ans = parseInt(e.target.getAttribute("data-value"));
    ansArray.push(ans);
    setQno((prev) => prev + 1);
    if (qno + 1 === 64) {
      setShow(false);
      computeScore();
    }
  }

  return (
    <div className="screen-bg">
      {show ? (
        <div className="quiz-bg">
          <p style={{ textAlign: "center", marginBottom: "2%" }}>
            Question {qno + 1} of 64
          </p>
          <h3 style={{ textAlign: "center", marginBottom: "2%" }}>
            {questions[qno]}
          </h3>
          <Row>
            <Col>
              <div className="answers">
                <div
                  data-value="0"
                  onClick={handleClick}
                  style={{ backgroundColor: "#f0e5e5" }}
                >
                  Does Not Apply
                </div>
                <div data-value="1" onClick={handleClick}>
                  No Stress At All
                </div>
                <div data-value="2" onClick={handleClick}>
                  Very Little Stress
                </div>
                <div data-value="3" onClick={handleClick}>
                  Somewhat Stress
                </div>
              </div>
            </Col>
            <Col>
              <div className="answers">
                <div data-value="4" onClick={handleClick}>
                  Average Stress
                </div>
                <div data-value="5" onClick={handleClick}>
                  Much Stress
                </div>
                <div data-value="6" onClick={handleClick}>
                  Too Much Stress
                </div>
                <div data-value="7" onClick={handleClick}>
                  Unbearable Stress
                </div>
              </div>
            </Col>
          </Row>
        </div>
      ) : (
        <ScoreCard results={results} />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  };
};

export default connect(mapStateToProps)(StudentStressScale);
